import { Divider, Form } from 'antd'
import { FC } from 'react'
import Lacquer from './lacquer'
import { NamePath } from 'antd/es/form/interface'
import _ from 'lodash'

interface LacquersProps {
    namePath: NamePath
}

const Lacquers: FC<LacquersProps> = ({ namePath }) => {
    const name = _.concat(namePath, 'lacquers')

    return (
        <Form.List name={name}>
            {(fields, { add, remove }) => {
                if (fields.length === 0) {
                    return null
                }

                return (
                    <>
                        <Divider orientation={'left'}>Лаки</Divider>
                        {fields.map((field, i) => {
                            return <Lacquer name={field.name} key={field.key} />
                        })}
                    </>
                )
            }}
        </Form.List>
    )
}

export default Lacquers
